import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { theme } from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { MedicationCartProvider } from './contexts/MedicationCartContext';
import './i18n'; // Initialize i18n
import './styles/print.css'; // Print styles for prescriptions

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;

function withGoogle(node: React.ReactNode) {
  if (!GOOGLE_CLIENT_ID) return node;
  return <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{node}</GoogleOAuthProvider>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            {withGoogle(
              <MedicationCartProvider>
                <App />
              </MedicationCartProvider>
            )}
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
